import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'


class AdminAppVersion extends Component {

  constructor(props){
    super(props);
    this.state={
      data: {
      	id: '',
      	name: '',
      	value: '',
      },
      errorMsg: '',
      isButtonDisabled: false,
    }
  }

  componentDidMount() {
    let data = Object.assign({}, this.state.data)
    let url = 'app/version'
    api.getResponse(this.props.user.accessToken, url).then((result) => {
      if (result.status === 'success') {
        data.id = result.data.id
        data.name = result.data.name
        data.value = result.data.value
        this.setState({data:data})
      }
      else {
      	let errorMsg = Object.assign({}, this.state.errorMsg)
      	errorMsg = result.message;
      	this.setState({ errorMsg: errorMsg});
      }
    })
    .catch((err) => {
       this.setState({ errorMsg: 'Exception in Fetching Details'});
    })
  }


  onInputChange = (e) => {
    let data = Object.assign({}, this.state.data)
    data[e.target.name] = e.target.value;  
    this.setState({data: data});
  }

  handleUpdate = (e) => { 
    e.preventDefault() 
    this.setState({ 
      isButtonDisabled: true
    });

    if(this.state.data.value === ''){
      this.setState({errorMsg: 'Value cannot be empty'})
      return
    }
    let values;
    let url = '/admin/update/app/version'
    values = {

      id: parseInt(this.state.data.id),
      value: this.state.data.value
    }
    api.putValuesApi(this.props.user.accessToken, url, values).then((result) =>{
        if(result.status === 'success'){
          this.setState({errorMsg: result.message})
        }
        else{
          this.setState({errorMsg: result.message})
        }
    })
  }

  render(){
  	return(
  		<div>
        <Grid>
          <GridCell span="12">
            <Card style={{padding: '25px'}}>
              <Typography use="headline6" align="center" >PWA App Version </Typography>
            </Card>
          </GridCell>
        </Grid>
        <br/>
      	<Grid> 
        <GridCell span = "12">
          <GridCell span = "6">
            <Typography use = "subtitle2">{this.state.data.name}:</Typography>
          </GridCell>

          <GridCell span="6">
            <TextField className='text_input' label="Value" autoComplete="off" name="value" onChange={this.onInputChange} value={this.state.data.value}/>
          </GridCell>
        </GridCell>

        <GridCell span = "4">
            <Button raised onClick = {this.handleUpdate} disabled = {this.state.isButtonDisabled} >Update</Button>
        </GridCell>
        <GridCell span = "8" />
        <GridCell span = "12">
            <StatusMessage error_msg = {this.state.errorMsg} />
        </GridCell>
      	</Grid>
      </div>
  		)
  }


}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminAppVersion);


// WEBPACK FOOTER //
// ./src/views/admin/AdminAppVersion.jsx